export class BaseMenuItem {
    constructor(type, icon) {
        this.type = type;
        this.icon = icon;
    }
}